import { Apply } from '../../models/apply';
import { ActivatedRoute, Router} from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ItemCandidateComponent } from '../item-candidate/item-candidate.component';
import { Observable } from "rxjs";
import { JobOffersService } from '../../services/job-offers.service';
import { HvRecommendedService } from '../../services/hv-recommended.service';
import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';
import { ReportService } from '../../services/report.service';
import { Constants } from '../constants';

@Component({
  selector: 'app-hv-recommended',
  templateUrl: './hv-recommended.component.html',
  styleUrls: ['./hv-recommended.component.css']
})

export class HvRecommendedComponent implements OnInit{

  @Input() user;
  @Input() index;
  @Input() jod2;
  @Input() userId: string;
  jobId: string;
  premium: string;
  job: JobsOffer;
  create: boolean;
  role: string;
  email: string;
  recs: any;
  max: number = 5;
  page: number = 1;
  total: number = 0;
  @Input() nameComponent;
  errorMessage: string;
  reportDescription: string = null;
  loading_job: boolean = false;
  public STATUS = Constants;
  public step: number;
  public filled: boolean;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(public dialog: MdDialog,
              private route: ActivatedRoute,
              public dialogRef: MdDialogRef<HvRecommendedComponent>,
              private jobRecommended: HvRecommendedService,
              private configurationService: ConfigurationService,
              private reportService: ReportService,
              @Inject(MD_DIALOG_DATA) public data: any,
              ) {
  }

  ngOnInit () {
    this.loading_job= true;
    this.job = this.data.job;
    this.create = this.data.create;
    
    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }
    
    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.role = localStorage.getItem('role');
        }
      }
    );
    this.recs=this.data.rec;
    this.total=this.data.total_rec;
    this.loading_job= false;
    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];
      
      
    });
  
  }
    callhvrecommended(jobId,page){
      this.loading_job= true;
      this.jobRecommended.getHvRecommendedByJob(jobId, page)
      .subscribe(
        data => {
        this.total = data.pagination.total; 
        this.recs = data.recommended;
        this.loading_job= false;
        },
        error => {
          this.errorMessage = <any>error;
          
          }
      );

        // this.recs = this.jobRecommended.getHvRecommendedByJob(jobId, page)
        // .do(data => {
        //   let recommendeds:any = data.recommended;
        //   this.total = data.pagination.total;         
        //   let list = [];
        //   // if (this.create){
        //     recommendeds.forEach(element => {
        //       element.firstname = element.firstname;
        //       element.lastname = element.lastname;
        //       element.photo = element.photo;
        //       element.user_id = element.id;
        //       element.email = element.email;
        //       element.description = '';
              
        //       list.push(element);
        //     });
        //     this.loading_job= false; 
        //   }
        // ).map(data => data.recommended);
    }
    validEmail () {
      if (this.email != undefined && this.email != '') {
        let a = this.emailRegex.test(this.email);
        return a;
      }
      return true;
    }

    onInvite(user_id) {
     this.openDialogJobSelectorDialog(user_id);
    }
    searchRec(page) {
      this.page = page;
      this.callhvrecommended(this.job.id, this.page);  
    }
  
    openDialogJobSelectorDialog(user_id) {
      let dialogRef = this.dialog.open(JobSelectorDialogComponent);
      dialogRef.componentInstance.createInvite=true;
      dialogRef.componentInstance.UserID=user_id;
      dialogRef.componentInstance.JobName=this.job.title +" - "+ this.job.venue.name;
      dialogRef.componentInstance.JobID=this.job.id;
      dialogRef.componentInstance.Jobemail=user_id.email;
      dialogRef.componentInstance.nameComponent='Invitación';
      dialogRef.componentInstance.hv=1;
      
    }


  getPercentage(competence) {
    let competence_apply_id = '';
    let total = 0;
    let value = [];
    let i = competence.length;
    competence.forEach(elementCompetence => {
      elementCompetence.answers.forEach(elementAnswer => {
        if (competence_apply_id == '') {
          competence_apply_id = elementCompetence.competence_apply_id;
        }
        if (competence_apply_id != elementCompetence.competence_apply_id) {
          value.push ({name: competence_apply_id, value: total});
          competence_apply_id = elementCompetence.competence_apply_id;
          total = 0;
        }
        total = total + elementAnswer.option.percentage;
      });
      i--;
    });
    if (i > 0) {
      value.push ({name: competence_apply_id, value: total});
    }
    console.log(value);
    return (value);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/hv-recommended/hv-recommended.component.ts